<template>
  <div class="header-container">
    <header>
      <a href="https://interview.co" class="nav-logo-link"><img src="images/interview-logo.svg" alt=""
          class="nav-logo" /></a>
      <div class="button-area">
        <router-link :to="{ name: 'LoginView', query: { redirect: '/pricing' }, params: { lang: $route.params.lang } }" class="button button--without-bg"
          name="RedirectLoginPageBtn">
          {{ resource['pricing.LoginButton'] }}
        </router-link>
        <router-link :to="{ name: 'RegisterView', params: { lang: $route.params.lang } }" class="button button--dark-bg" name="MainPageTryForFreeBtn">
          {{ resource['pricing.TryButton'] }}
        </router-link>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'LandingPageNavbar',
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.header-container {
  width: 100%;
  border-bottom: 1px solid #E4E4E4;
  background: #FFF;
}

header {
  display: flex;
  max-width: 1152px;
  padding: 16px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    display: flex;
    align-items: center;
  }

  .button-area {
    display: flex;
    gap: 8px;
  }

  .button {
    display: flex;
    height: 30px;
    padding: 4px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-family: Ubuntu;
    font-size: 13px;
    font-weight: 500;
    line-height: 22px;
    /* 169.231% */
    letter-spacing: 0.46px;
    text-transform: capitalize;
    border-radius: 50px;

    &--dark-bg {
      background: #353535;
      color: #FFF;
    }

    &--without-bg {
      border: 1px solid #777;
      color: #353535;
    }
  }
}

.nav-logo {
  width: 200px;

  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    width: 148px;
  }
}
</style>
